import * as yup from 'yup';

const ChangeEmailSchema = yup.object().shape({
    password: yup.string()
        .required('Required'),
    email: yup.string()
        .email('Please Enter a valid Email Address')
        .required('Required')
});

export default ChangeEmailSchema;